<div class="strength">
  <ul class="strengthBar mt-2">
    <li class="point" [style.background-color]="bar0"></li>
    <li class="point" [style.background-color]="bar1"></li>
    <li class="point" [style.background-color]="bar2"></li>
    <li class="point" [style.background-color]="bar3"></li>
  </ul>

  @if (passwordToCheck?.length) {
    <p class="text-center mb-0" [style.color]="messageColor">{{ message }}</p>
  }
</div>

@if (showRequirements) {
  <mat-card class="mat-mdc-card mdc-card">
    <mat-card-content class="mat-mdc-card-content">
      <div class="info-row">
        @if (!checks.lowerLetters) {
          <mat-icon role="img" color="warn"
            class="mat-icon notranslate mat-warn material-icons mat-ligature-font"
          data-mat-icon-type="font">error</mat-icon>
        }
        @if (checks.lowerLetters) {
          <mat-icon role="img" color="primary"
            class="mat-icon notranslate mat-primary material-icons mat-ligature-font"
          data-mat-icon-type="font">done</mat-icon>
        }
        <span>
          {{ 'PASSWORD_STRENGTH.LOWER_CASE' | transloco}}
        </span>
      </div>
      <div class="info-row">
        @if (!checks.upperLetters) {
          <mat-icon role="img" color="warn"
            class="mat-icon notranslate mat-warn material-icons mat-ligature-font"
          data-mat-icon-type="font">error</mat-icon>
        }
        @if (checks.upperLetters) {
          <mat-icon role="img" color="primary"
            class="mat-icon notranslate mat-primary material-icons mat-ligature-font"
          data-mat-icon-type="font">done</mat-icon>
        }
        <span>
          {{ 'PASSWORD_STRENGTH.UPPER_CASE' | transloco}}
        </span>
      </div>
      <div class="info-row">
        @if (!checks.numbers) {
          <mat-icon role="img" color="warn"
            class="mat-icon notranslate mat-warn material-icons mat-ligature-font"
          data-mat-icon-type="font">error</mat-icon>
        }
        @if (checks.numbers) {
          <mat-icon role="img" color="primary"
            class="mat-icon notranslate mat-primary material-icons mat-ligature-font"
          data-mat-icon-type="font">done</mat-icon>
        }
        <span>
          {{ 'PASSWORD_STRENGTH.NUMBER' | transloco}}
        </span>
      </div>
      <div class="info-row">
        @if (!checks.symbols) {
          <mat-icon role="img" color="warn"
            class="mat-icon notranslate mat-warn material-icons mat-ligature-font"
          data-mat-icon-type="font">error</mat-icon>
        }
        @if (checks.symbols) {
          <mat-icon role="img" color="primary"
            class="mat-icon notranslate mat-primary material-icons mat-ligature-font"
          data-mat-icon-type="font">done</mat-icon>
        }
        <span>
          {{ 'PASSWORD_STRENGTH.SPECIAL_CHARACTER' | transloco}}
        </span>
      </div>
      <div class="info-row">
        @if (!checks.minLength) {
          <mat-icon role="img" color="warn"
            class="mat-icon notranslate mat-warn material-icons mat-ligature-font"
          data-mat-icon-type="font">error</mat-icon>
        }
        @if (checks.minLength) {
          <mat-icon role="img" color="primary"
            class="mat-icon notranslate mat-primary material-icons mat-ligature-font"
          data-mat-icon-type="font">done</mat-icon>
        }
        <span>
          {{ 'PASSWORD_STRENGTH.MIN_LENGTH' | transloco}}
        </span>
      </div>
    </mat-card-content>
  </mat-card>
}